import { Observable } from 'rxjs/Observable';
import { HttpService } from './../../globals/providers/http.service';

import {
	ISignInRequest,
	IUserStatusReq,
	ISendOtpRequest,
	IUserStatusResponse,
} from './http-requests';
import {
	ISendSmsOtpResponse,
	ILoginResponse,
	ITwoFactorAuthenticationInfo,
	IGetLoginResponse,
} from './http-responses';
import { AppEndpoints } from '../app.endpoints';
import { OTPReason } from './static/enums';
import { IUserData, UserData } from '../../globals/classes/userData';
import { map, tap } from 'rxjs/operators';
import { CardLoginResponse, ICardLoginResponse } from './existing-onboarding-customer/responses';
import { ICardLoginRequest } from './existing-onboarding-customer/requests';
import { timer } from 'rxjs';

export class UserAuth {
	public static getLogin(returnUrl: string): Observable<IGetLoginResponse> {
        return HttpService.post<IGetLoginResponse>(AppEndpoints.getLogin, { returnUrl });
    }
	
	public static cardLogin(request: ICardLoginRequest): Observable<CardLoginResponse> {
		return HttpService.post<ICardLoginResponse>(AppEndpoints.cardLogin, request).pipe(
			map((response) => new CardLoginResponse(response))
		);
		//let dummyResponse: ICardLoginResponse = UserAuth.createDummyCardLoginResponse(request);

		//return timer(2500)
		//	.pipe(map(() => new CardLoginResponse(dummyResponse)));
	}

	public static cardInitUser(request: ICardLoginRequest): Observable<CardLoginResponse> {
		return HttpService.post<ICardLoginResponse>(AppEndpoints.cardInitUser, request).pipe(
			map((response) => new CardLoginResponse(response))
		);
		//let dummyResponse: ICardLoginResponse = UserAuth.createDummyCardLoginResponse(request);

		//return timer(2500)
		//	.pipe(map(() => new CardLoginResponse(dummyResponse)));
	}

	public static signIn(request: ISignInRequest): Observable<ITwoFactorAuthenticationInfo> {
		request.userID = request.username;
		return HttpService.post<ITwoFactorAuthenticationInfo | ILoginResponse>(
			AppEndpoints.signIn,
			request
		).pipe(
			map((resp) => {
				return this.isOldResponse(resp) ? resp : resp.additionalAuthenticationInfo;
			}),
			tap(
				(resp) =>
					!!resp &&
					UserData.update({
						userId: resp.actualUserId,
						hasSMSOtp: !!resp.verificationCodeInfo
							? resp.verificationCodeInfo.hasOtp
							: true,
						maskedPhoneNumber: !!resp.verificationCodeInfo
							? resp.verificationCodeInfo.target
							: null,
					})
			)
		);
	}

	public static checkUserStatus(username: string, mock = false): Observable<IUserStatusResponse> {
		const request: IUserStatusReq = {
			username: username,
		};
		if (mock == true) {
			return UserAuth.checkUserStatusMock(request);
		} else {
			return UserAuth.checkUserStatusActual(request, username);
		}
	}

	public static requestOtp(userId: string, reason: OTPReason): Observable<ISendSmsOtpResponse> {
		const request: ISendOtpRequest = {
			userId: userId,
			reason: reason.toString(),
		};

		return HttpService.post<ISendSmsOtpResponse>(AppEndpoints.requestOtp, request);
	}

	private static isOldResponse(
		response: ITwoFactorAuthenticationInfo | ILoginResponse
	): response is ITwoFactorAuthenticationInfo {
		if (!response || (response as ITwoFactorAuthenticationInfo).actualUserId) {
			return true;
		}
		return false;
	}
	private static checkUserStatusActual(
		request: IUserStatusReq,
		username: string
	): Observable<IUserStatusResponse> {
		return HttpService.post<IUserStatusResponse>(AppEndpoints.userStatus, request).pipe(
			map((response) => {
				const userData: IUserData = {
					userId: username,
					userType: !!response.userType ? response.userType.trim() : null,
				};
				UserData.update(userData);
				return response;
			})
		);
	}

	private static checkUserStatusMock(request: IUserStatusReq): Observable<IUserStatusResponse> {
		let dummyResponse: IUserStatusResponse = {
			// changePassword
			userStatus: 'INIT',
			userType: 'PERSON',
			ux: null
			// createPassword
			// userStatus: 'NEW',
			// userType: 'COMP_USER',
		};

		return timer(2500).pipe(map(() => dummyResponse));
	}

	private static createDummyCardLoginResponse(request: ICardLoginRequest): ICardLoginResponse {
		let dt = new Date();
		dt.setHours(dt.getHours() + 2);

		let dummyResponse: ICardLoginResponse = {
			applicationId: request.applicationId,
			userProfile: {
				cardNumber: request.cardNumber,
				customerCode: '123456789',
			},
		};
		return dummyResponse;
	}
}
